import GeneratedUploadLinkStore from "./generated/GeneratedUploadLinkStore"

class UploadLinkStore extends GeneratedUploadLinkStore {

}

export const uploadLinkStore = new UploadLinkStore()
